import { useState } from "react";
import DashboardLayout from "../components/DashboardLayout";
import ComingSoon from "../components/sinp/ComingSoon";


export default function Dashboard() {
  
  return (
    <DashboardLayout>
  
      <ComingSoon />
    
    </DashboardLayout>

  );
}
